import * as ActivityClientState from '/druid/constants/ActivityClientState';
import * as DictateState from '/druid/constants/DictateState';
import clearSuggestedActions from '/druid/actions/clearSuggestedActions';
import connect from '/druid/actions/connect';
import createStore, {
  withDevTools as createStoreWithDevTools,
  withOptions as createStoreWithOptions
} from '/druid/createStore';
import disconnect from '/druid/actions/disconnect';
import dismissNotification from '/druid/actions/dismissNotification';
import emitTypingIndicator from '/druid/actions/emitTypingIndicator';
import isForbiddenPropertyName from '/druid/utils/isForbiddenPropertyName';
import markActivity from '/druid/actions/markActivity';
import OneOrMany from '/druid/types/OneOrMany';
import postActivity from '/druid/actions/postActivity';
import sendEvent from '/druid/actions/sendEvent';
import sendFiles from '/druid/actions/sendFiles';
import sendMessage from '/druid/actions/sendMessage';
import sendMessageBack from '/druid/actions/sendMessageBack';
import sendPostBack from '/druid/actions/sendPostBack';
import setDictateInterims from '/druid/actions/setDictateInterims';
import setDictateState from '/druid/actions/setDictateState';
import setLanguage from '/druid/actions/setLanguage';
import setNotification from '/druid/actions/setNotification';
import setSendBox from '/druid/actions/setSendBox';
import setSendTimeout from '/druid/actions/setSendTimeout';
import setSendTypingIndicator from '/druid/actions/setSendTypingIndicator';
import singleToArray from '/druid/utils/singleToArray';
import startDictate from '/druid/actions/startDictate';
import startSpeakingActivity from '/druid/actions/startSpeakingActivity';
import stopDictate from '/druid/actions/stopDictate';
import stopSpeakingActivity from '/druid/actions/stopSpeakingActivity';
import submitSendBox from '/druid/actions/submitSendBox';
import warnOnce from '/druid/utils/warnOnce';

import type { DirectLineActivity } from '/druid/types/external/DirectLineActivity';
import type { DirectLineAnimationCard } from '/druid/types/external/DirectLineAnimationCard';
import type { DirectLineAttachment } from '/druid/types/external/DirectLineAttachment';
import type { DirectLineAudioCard } from '/druid/types/external/DirectLineAudioCard';
import type { DirectLineCardAction } from '/druid/types/external/DirectLineCardAction';
import type { DirectLineHeroCard } from '/druid/types/external/DirectLineHeroCard';
import type { DirectLineJSBotConnection } from '/druid/types/external/DirectLineJSBotConnection';
import type { DirectLineOAuthCard } from '/druid/types/external/DirectLineOAuthCard';
import type { DirectLineReceiptCard } from '/druid/types/external/DirectLineReceiptCard';
import type { DirectLineSignInCard } from '/druid/types/external/DirectLineSignInCard';
import type { DirectLineSuggestedAction } from '/druid/types/external/DirectLineSuggestedAction';
import type { DirectLineThumbnailCard } from '/druid/types/external/DirectLineThumbnailCard';
import type { DirectLineVideoCard } from '/druid/types/external/DirectLineVideoCard';
import type { GlobalScopePonyfill } from '/druid/types/GlobalScopePonyfill';
import type { WebChatActivity } from '/druid/types/WebChatActivity';

const Constants = { ActivityClientState, DictateState };
const version = process.env.npm_package_version;

export {
  clearSuggestedActions,
  connect,
  Constants,
  createStore,
  createStoreWithDevTools,
  createStoreWithOptions,
  disconnect,
  dismissNotification,
  emitTypingIndicator,
  isForbiddenPropertyName,
  markActivity,
  postActivity,
  sendEvent,
  sendFiles,
  sendMessage,
  sendMessageBack,
  sendPostBack,
  setDictateInterims,
  setDictateState,
  setLanguage,
  setNotification,
  setSendBox,
  setSendTimeout,
  setSendTypingIndicator,
  singleToArray,
  startDictate,
  startSpeakingActivity,
  stopDictate,
  stopSpeakingActivity,
  submitSendBox,
  version,
  warnOnce
};

export type {
  DirectLineActivity,
  DirectLineAnimationCard,
  DirectLineAttachment,
  DirectLineAudioCard,
  DirectLineCardAction,
  DirectLineHeroCard,
  DirectLineOAuthCard,
  DirectLineJSBotConnection,
  DirectLineReceiptCard,
  DirectLineSignInCard,
  DirectLineSuggestedAction,
  DirectLineThumbnailCard,
  DirectLineVideoCard,
  OneOrMany,
  GlobalScopePonyfill,
  WebChatActivity
};
